<template>
  <div class="select-box" :class="size">
    <div
      v-if="!isSelectedInput"
      class="select-box-text"
      :class="{ 'large': !isOutline }"
    >{{ selectedString }}</div>
    <v-autocomplete
      v-model="selected"
      :items="itemList"
      :item-text="itemTextKey"
      :item-value="itemValueKey"
      class="UXautocomplete"
      :class="{ 'UXselect' : isOutline, 'medium' : size === 'medium', 'large' : size === 'large' , 'larger' : size === 'larger', 'isShowSelectedLen': isShowSelectedLen && selected.filter(v => v !== 'ALL').length && selected.length < 2, 'isShowAllSelectedLen': !isAllItem && selected.length > 0 }"
      :menu-props="{contentClass}"
      :search-input.sync="search"
      :no-data-text="noDataText"
      :placeholder="placeholder"
      multiple
      outline
      hide-details
      solo
    >
      <template v-slot:selection="data">
        {{ data.item[itemTextKey] }}
      </template>
      <template v-slot:item="data">
        <template>
          <v-list-tile-content>
            <v-list-tile-title
              v-if="!data.item.isHeader"
              class="checkbox-box"
            >
              <div class="UXcheckbox small">
                <input
                  class="checkbox-item"
                  :class="data.tile.props.value ? 'checked': ''"
                  type="checkbox"
                  :name="data.tile.props[itemTextKey]"
                  :checked="data.tile.props.value"
                >
                <i :class="data.tile.props.value ?
                          'v-icon mdi mdi-checkbox-marked theme--light accent--text'
                          : 'v-icon mdi mdi-checkbox-blank-outline theme--light'"
                ></i>
                <label :for="data.item[itemTextKey]"
                       class="v-label theme--light"
                       style="left: 0px; right: auto; position: relative;font-weight: 500"
                       :style="data.tile.props.value ? 'color:#ff8c8c;font-weight:700;': ''"
                       :class="data.tile.props.value ? 'checked': ''"
                >{{ data.item[itemTextKey] }}</label>
              </div>
            </v-list-tile-title>
            <v-list-tile-title
              v-else
              class="header-title"
              v-text="data.item[itemTextKey]"
            ></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'multiSelectBox',
  props: {
    itemList: { // 셀렉트 박스 배열 리스트
      type: Array,
      required: true
    },
    itemValueKey: { // 셀렉트 박스에서 사용할 value
      type: String,
      default: 'value',
      required: false
    },
    itemTextKey: { // 셀렉트 박스에서 사용할 key
      type: String,
      default: 'name',
      required: false
    },
    parentDataKey: { // 상위컴포넌트에서 어떤 데이터를 업데이트 할지 key 값
      type: String,
      required: true
    },
    parentData: { // 상위컴포넌트에서 변경되는 데이터
      type: Array,
      required: true
    },
    isOutline: { // css outline 여부
      type: Boolean,
      default: true,
      required: false
    },
    size: { // css 셀렉트 박스 사이즈
      type: String,
      default: '',
      required: false
    },
    isShowSelectedLen: { // n개 선택 됨 문구로 표시할지, 선택된 아이템 외 (n) 으로 표시할지 여부
      type: Boolean,
      default: false,
      required: false
    },
    isImmediate: {
      type: Boolean,
      default: true,
      required: false
    },
    placeholder: {
      type: String,
      default: 'タグの検索',
      required: false
    },
    noDataText: {
      type: String,
      default: '検索結果がありません。',
      required: false
    },
    noDataAll: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      selectedString: '',
      isSelectedInput: false,
      search: '',
      selectedArr: ['ALL'],
      allItem: 'ALL',
      isAllItem: true,
      notAssignItem: 'NOTASSIGN',
      oldSelected: []
    }
  },
  watch: {
    search (val) {
      if (val && val.length) {
        this.isSelectedInput = true
        if (this.selected && this.selected.length) {
          this.oldSelected = JSON.parse(JSON.stringify(this.selected))
          this.selected = []
        }
      } else {
        this.isSelectedInput = false
        if (this.oldSelected && this.oldSelected.length && (!this.selected || !this.selected.length)) {
          this.selected = JSON.parse(JSON.stringify(this.oldSelected))
        }
      }
      this.$emit('subEvent', val)
    },
    selected () {
      // 상위 컴포넌트의 selected 데이터를 컴포넌트에서 바꿔주는 데이터로 연동시키는 이벤트
      this.$emit('selectedChange', this.parentDataKey, this.selected)
    },
    parentData: {
      immediate: this.isImmediate,
      deep: true,
      handler () {
        if (JSON.stringify(this.selectedArr) !== JSON.stringify(this.parentData)) {
          this.selectedArr = this.parentData
          this.setSelectedString(this.parentData)
        }
      }
    },
    itemList (val) {
      if (this.itemList[0] && this.itemList[0].value !== 'ALL') {
        this.isAllItem = false
        this.selectedArr = this.isAllItem ? ['ALL'] : []
        this.allItem = this.isAllItem ? 'ALL' : ''
        this.selectedString = ''
        this.selected = []
      } else {
        this.itemList = val
        this.setSelectedString(this.parentData)
      }
    }
  },
  created () {
    this.setSelectedString(this.selectedArr)
  },
  computed: {
    selected: {
      get () {
        // ALL 데이터를 사용하지않고 빈값이 전체 출력일 때
        if (this.noDataAll) {
          return this.selectedArr[0] === 'ALL' ? [] : this.selectedArr
        } else {
          return this.selectedArr
        }
      },
      set (value) {
        this.selectedArr = this.getSelectedArr(value)
        this.setSelectedString(value)
      }
    },
    contentClass () {
      let menuClass = 'UXautoMenu'
      if (this.size) {
        menuClass = `${menuClass} ${this.size}`
      }
      return menuClass
    }
  },
  methods: {
    searchInputReset () {
      this.isSelectedInput = false
    },
    getSelectedArr (value) {
      const list = this.itemList
      const checkboxItemList = list.filter(item => !item.isHeader && item[this.itemValueKey]).map(item => item[this.itemValueKey])
      if (!this.isShowSelectedLen) {
        if ((Array.isArray(value) && checkboxItemList.length === value.length) || checkboxItemList.length === 1) {
          return this.isAllItem ? [this.allItem] : checkboxItemList
        }
      }
      if (Array.isArray(value) && value.indexOf(this.allItem) !== -1 && value.length > 1) {
        if (value.indexOf(this.allItem) === (value.length - 1)) {
          value = value.splice(value.indexOf(this.allItem))
        } else {
          value = value.slice(value.indexOf(this.allItem) + 1)
        }
      }

      if (Array.isArray(value) && value.indexOf(this.notAssignItem) !== -1 && value.length > 1) {
        if (value.indexOf(this.notAssignItem) === (value.length - 1)) {
          value = value.splice(value.indexOf(this.notAssignItem))
        } else {
          value = value.splice(value.indexOf(this.notAssignItem) + 1, value.length - 1)
        }
      }
      return value
    },
    setSelectedString (value) {
      if (value.length) {
        this.searchInputReset(value)
      }
      const selectedArray = this.selectedArr
      if (Array.isArray(selectedArray) && selectedArray.length) {
        let stringArr = []
        const itemList = this.itemList
        selectedArray.forEach((value) => {
          const findItem = itemList.find(item => item[this.itemValueKey] === value)
          if (findItem && findItem.hasOwnProperty(this.itemTextKey)) {
            stringArr.push(findItem[this.itemTextKey])
          }
        })

        if (stringArr.length > 1) {
          const itemListLeng = itemList.filter(item => !item.isHeader && item[this.itemValueKey]).length
          const newSelectedStr = this.isShowSelectedLen ? `${this.selected.length}個 選択済み` : `${stringArr[0]} 外 (${stringArr.length - 1})`
          const replace = itemListLeng === stringArr.length && this.isAllItem ? `全体` : newSelectedStr
          this.selectedString = replace
        } else {
          if (this.isShowSelectedLen) {
            if (stringArr.length) {
              this.selectedString = `${this.selected.length}個 選択済み`
            } else {
              this.selectedString = ''
            }
          } else {
            const replace = stringArr[0]
            this.selectedString = replace
          }
        }
      } else {
        const replace = ''
        this.selectedString = replace
      }
    }
  }
}
</script>

<style lang="scss">
.select-box {
  width: 200px;
  position: relative;
  &.medium {
    width: 330px;
  }
  &.large {
    width: 100%;
    max-width: 500px;
  }
  &.larger {
    width: 100%;
    max-width: 590px;
  }
  .select-box-text {
    position: absolute;
    top: 7px;
    left: 11px;
    z-index: 1;
    color: #121212;
    font-weight: 500;
    font-size: 14px !important;

    &.large {
      font-weight: 400;
      font-size: 16px !important;
    }
  }

  .v-select__selections {
    max-height: 40px;
    color: transparent !important;
    caret-color: transparent !important;
  }
}

.checkbox-item {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip:rect(0,0,0,0);
  border: 0
}

.header-title {
  font-weight: 500;
  color: #121212;
}

.primary--text {
  color: #ff8c8c !important;
  caret-color: #ff8c8c !important;
  .header-title {
    color: #ff8c8c !important;
    font-weight: 700;
  }
}
.UXautoMenu {
  &.medium {
    max-width: 330px;
  }
  &.large {
    max-width: 500px;
  }
}

.UXautocomplete {
  &.isShowSelectedLen {
   .v-select__selections {
     input {
       margin-left: 50px;
     }
   }
  }
  &.isShowAllSelectedLen {
    .v-select__selections {
      input {
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/multiSelectBox.vue